import { Modal } from "react-bootstrap";
import { ApiSchemaFaceToFace } from '../../models/api/operatorProfile';
import { useForm } from "react-hook-form";
import { FormErrorMessage } from "../../components";
import { useFunctionalityInputChecker } from "../../pages/hooks/functionalityInputChecker";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  faceToFaceAssignmentData: ApiSchemaFaceToFace;
  setMileAgeToggleHandler: any;
  onSaveHandler: any;
};

export function ModalFaceToFaceAssignment(props: Props): JSX.Element {
  const { show, handleShow, setMileAgeToggleHandler, faceToFaceAssignmentData, onSaveHandler } = props;
  const { handleLimitDecimalPlaces } = useFunctionalityInputChecker()
  const { register, handleSubmit, formState: { errors } } = useForm<ApiSchemaFaceToFace>();
  return (
    <Modal show={show} onHide={() => handleShow(false)} centered>
              {/*@ts-ignore */}
        <Modal.Header closeButton>
        <Modal.Title>Update Face to Face Assignment</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSaveHandler)}>
        <Modal.Body>
          <div className="component-card rounded mb-3">
            <div className="component-card-header d-flex align-items-center justify-content-between rounded-top border"
              aria-expanded="true"
              aria-controls="Updatesystem-OPI-collapse"
            >
              <div className="col-6 ps-0">Mileage</div>
              <div className="col-6 pe-0 text-end">
                <button
                  type="button"
                  className={faceToFaceAssignmentData?.isMileageEnabled ? 'btn btn-toggle active  on-off-btn' : 'btn btn-toggle  on-off-btn'}
                  onClick={() => { setMileAgeToggleHandler(!faceToFaceAssignmentData?.isMileageEnabled) }}
                >
                  <div className="handle"></div>
                </button>
              </div>
            </div>
            <div
              className={faceToFaceAssignmentData?.isMileageEnabled ? "component-card-body rounded-bottom  border-start border-end border-bottom collapse show" : "component-card-body rounded-bottom  border-start border-end border-bottom collapse"}
              id="Updatesystem-OPI-collapse"
            >
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="" className="position-relative required">Distance</label>
                    <div className="input-group ">
                      <input
                        type="text"
                        className="form-control"
                        {...register('mileageDistance', { required: true })}
                        aria-describedby="mileageDistance"
                        placeholder="Input miles"
                        defaultValue={faceToFaceAssignmentData?.mileageDistance ?? 0} />
                      <span
                          className="input-group-text"
                          id="flat-rate"
                        >
                          Miles
                        </span>
                    </div>
                    {errors.mileageDistance && <FormErrorMessage message="required" />}
                  </div>
                  <div className="form-group mb-0">
                    <label htmlFor="" className="position-relative required">Additional Miles Rate</label>
                    <div className="input-group ">
                      <span
                          className="input-group-text"
                          id="flat-rate"
                        >
                          $
                        </span>
                      <input
                        type="text"
                        className="form-control"
                        {...register('mileageAdditionalRate', { required: true })}
                        aria-describedby="mileageAdditionalRate"
                        placeholder="Rate"
                        defaultValue={faceToFaceAssignmentData?.mileageAdditionalRate ?? 0}
                        onInput={(event) => handleLimitDecimalPlaces(event, 2)} />
                    </div>
                    {errors.mileageAdditionalRate && <FormErrorMessage message="required" />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-link text-uppercase text-site" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleShow(false);
          }}
          >Cancel</button>
          <button className="btn btn-primary text-uppercase form-submit-btn" type="submit">Save</button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
